var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6812 14.4439L12.0367 1.2032C11.6116 0.466952 10.8502 0.0273438 9.99999 0.0273438C9.14979 0.0273438 8.38839 0.466952 7.96331 1.2032L0.318837 14.4438C-0.106279 15.1802 -0.106279 16.0593 0.318837 16.7956C0.743954 17.5319 1.50528 17.9714 2.35551 17.9714H17.6445C18.4947 17.9714 19.256 17.5318 19.6812 16.7956C20.1063 16.0593 20.1063 15.1802 19.6812 14.4439ZM18.6664 16.2098C18.4531 16.5792 18.0711 16.7998 17.6445 16.7998H2.35551C1.92887 16.7998 1.54684 16.5792 1.33356 16.2098C1.12028 15.8403 1.12028 15.3992 1.33356 15.0298L8.97812 1.7891C9.1914 1.41965 9.57343 1.1991 10 1.1991C10.4266 1.1991 10.8087 1.41965 11.0219 1.7891L18.6665 15.0298C18.8797 15.3992 18.8797 15.8403 18.6664 16.2098Z",
    fill: "#FF9700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41402 5.875H10.5857V11.7337H9.41402V5.875ZM9.99992 12.9055C9.56918 12.9055 9.21875 13.2559 9.21875 13.6866C9.21875 14.1174 9.56918 14.4678 9.99992 14.4678C10.4306 14.4678 10.7811 14.1174 10.7811 13.6866C10.7811 13.2559 10.4307 12.9055 9.99992 12.9055Z",
    fill: "#FF9700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.7d7aac09ddacedf94fdddb473ae90597.svg";
export { ForwardRef as ReactComponent };